import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <g>
        <line
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="255.566"
          y1="102.893"
          x2="255.566"
          y2="309.223"
        />

        <line
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="348.109"
          y1="126.072"
          x2="256.552"
          y2="126.072"
        />

        <line
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="348.109"
          y1="187.33"
          x2="256.552"
          y2="187.33"
        />

        <line
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          x1="348.109"
          y1="251.071"
          x2="256.552"
          y2="251.071"
        />
        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
		M57.72,343.785c0,0,33.112-18.212,64.569,0s51.324,9.934,68.708,0.828"
        />
        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
		M454.241,343.785c0,0-33.112-18.212-64.569,0s-51.324,9.934-68.708,0.828"
        />
        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
		M111.528,394.282c0,0,26.206,29.265,71.192,5.795c38.079-19.867,42.218,7.45,72.019,7.45"
        />
        <path
          fill="none"
          stroke="#131313"
          stroke-width="13"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
		M399.605,394.282c0,0-26.206,29.265-71.192,5.795c-38.079-19.867-42.218,7.45-72.019,7.45"
        />

        <circle fill="none" stroke="#131313" stroke-width="13" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="256.222" cy="335.507" r="25.662" />
      </g>
    </svg>
  );
};

export default Icon;
